import type { Link, PhrasingContent, Root, Text } from 'mdast';

import type { PullRequestReferenceOptions } from './pull-request-references';

import { buildPullRequestUrl, replacePullRequestReferences } from './pull-request-references';
import { linkifyMarkdownText } from './text-references';

type RemarkPullRequestReferenceOptions = PullRequestReferenceOptions & {
  onReference?: () => void;
};

function linkifyTextNode(
  node: Text,
  options: PullRequestReferenceOptions,
): PhrasingContent[] | null {
  return replacePullRequestReferences<PhrasingContent>(
    node.value,
    options,
    (value) => ({ type: 'text', value }),
    (match): Link => ({
      type: 'link',
      url: buildPullRequestUrl(match.options, match.number),
      children: [{ type: 'text', value: match.reference }],
    }),
  );
}

export default function remarkPullRequestReferences(options: RemarkPullRequestReferenceOptions) {
  return (tree: Root): void => {
    linkifyMarkdownText(tree, (node) => {
      const replacements = linkifyTextNode(node, options);
      if (replacements) {
        options.onReference?.();
      }
      return replacements;
    });
  };
}
